var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.iconComponent,_vm._b({tag:"component",staticClass:"icon-svg",on:{"click":function($event){return _vm.$emit('click', $event)}}},'component',_vm.iconProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }